import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import queryString from "querystring";

import {
	Button,
	ConfigProvider,
	Dropdown,
	Menu,
	Pagination,
	Row,
	Table,
} from "antd";
import Empty from "antd/es/empty/empty";
import moment from "moment";

import * as XLSX from "xlsx";

import orderApi from "../../apis/Order.api";
import queryLogApi from "../../apis/QueryLog.api";
import { toastAlert } from "../../components/AlertComponent";
import LinkComponent from "../../components/layout/LinkComponent";
import ReportDateSearchComponent from "../../components/report/ReportDateSearchComponent";
import ReportSettlementComponent from "../../components/report/ReportSettlementComponent";
import ReportStatisticsComponent from "../../components/report/ReportStatisticsComponent";
import { setLoading } from "../../redux/store/common/commonDuck";
import ApiService from "../../utils/ApiService";
import status from "../../utils/status";

const api = new ApiService();

const Reports = () => {
	const history = useHistory();
	const dispatch = useDispatch();

	const user = useSelector((state) => state.auth.user);
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [navClicked, setNavClicked] = useState("1");
	const queryJson = queryString.parse(
		history.location.search?.replace("?", "")
	);

	useEffect(() => {
		const level = queryJson?.level;
		if (!!level && level === "settlement") {
			if (navClicked !== "2") {
				setNavClicked("2");
				// window.history.pushState(null, null, 'reports')
			}
		}
	}, [queryJson]);

	useEffect(() => {
		window.scrollTo({
			top: 0,
		});
	}, []);

	const [searchOptions, setSearchOptions] = useState({
		// startDate: moment().subtract(1, 'months').startOf('day'),
		// startDate: moment().startOf("month"),
		startDate: moment().startOf("day"),
		endDate: moment().endOf("day"),
	});

	const [statistics, setStatistics] = useState({
		click: 0,
		purchases_num: 0,
		purchases_complete_num: 0,
		cvr: 0.0,
		combined_amount: 0,
		expected_profit_amount: 0,
		profit_amount: 0,
	});
	const [orderList, setOrderList] = useState([]);
	const [orderTotalList, setOrderTotalList] = useState([]);
	const [totalSize, setTotalSize] = useState(0);
	const [currentPageNumber, setCurrentPageNumber] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [offset, setOffset] = useState(0);
	const [orderType, setOrderType] = useState("created_at");
	const [orderBy, setOrderBy] = useState("desc");
	const [updateDate, setUpdateDate] = useState(moment());

	const [detail, setDetail] = useState(false);
	// const pageSize = 15;
	const columns = [
		{
			title: "브랜드명",
			dataIndex: "product_brand_name",
			key: "product_brand_name",
			width: 100,
			// sorter: (a, b) => {
			// },
		},
		{
			title: "상품명",
			width: 170,
			dataIndex: "product_name",
			key: "product_name",
			render: (value) => {
				return (
					<span
						style={{
							width: "100%",
							textAlign: "center",
							display: "block",
							whiteSpace: "nowrap",
							overflow: "hidden",
							maxWidth: 170,
							textOverflow: "ellipsis",
						}}
					>
						{value}
					</span>
				);
			},
		},
		{
			title: "옵션명",
			width: 150,
			dataIndex: "option_title",
			key: "option_title",
			render: (value, record) => {
				if (record.option_id) {
					return (
						<span
							style={{
								width: "100%",
								textAlign: "left",
								display: "block",
								whiteSpace: "nowrap",
								overflow: "hidden",
								maxWidth: 150,
								textOverflow: "ellipsis",
							}}
						>
							{record.option_title}
						</span>
					);
				}
			},
		},
		// {
		//     title: "상세주문번호",
		//     dataIndex: 'order_detail_id',
		//     key: 'order_detail_id'
		// },
		{
			title: "구매일자",
			dataIndex: "created_at",
			key: "created_at",
			width: 150,
			// sorter: (a, b) => {
			// },
			render: (value) => {
				if (value) {
					return moment(value).format("YYYY.MM.DD HH:mm");
				} else return "-";
			},
		},
		{
			title: "구매확정일자",
			dataIndex: "complete_date",
			key: "complete_date",
			width: 150,
			render: (value) => {
				if (value) {
					return moment(value).format("YYYY.MM.DD HH:mm");
				} else return "-";
			},
		},
		// {
		//     title: "ID",
		//     dataIndex: 'created_by_name',
		//     key: 'created_by_name',
		//     render: (value) => {
		//         // if (value.trim().length < 5) {
		//         // return value.trim().replace(/(?<=.{2})./gi, "*")
		//         return value?.trim().slice(0, 2) + "****"
		//         // }
		//         // else {
		//         //     // return value.trim().replace(/(?<=.{4})./gi, "*")
		//         //     return value.trim().slice(0, 4) + "*****"
		//         // }
		//     }
		// },
		// {
		// 	title: "이름",
		// 	dataIndex: "name",
		// 	key: "name",
		// 	render: (value) => {
		// 		let name = value?.trim().replace(" ", "");
		// 		if (name) {
		// 			if (name?.length < 3) {
		// 				// return value.replace(/(?<=.{1})./gi, "*")
		// 				return name?.slice(0, 1) + "*";
		// 			} else {
		// 				return name?.slice(0, 1) + "*" + name[name?.length - 1];
		// 			}
		// 		}
		// 	},
		// },
		{
			title: "주문/배송상태",
			dataIndex: "order_detail_status",
			key: "order_detail_status",
			render: (value) => {
				return status.matchingOrderStatus[value];
			},
		},
		{
			title: "판매금액",
			dataIndex: "total_price",
			key: "total_price",
			render: (value) => {
				return value.toLocaleString();
			},
		},
		{
			title: "수수료율",
			dataIndex: "commission_rate",
			key: "commission_rate",
			render: (value) => {
				if (value) {
					return `${value}%`;
				}
			},
		},
		{
			title: "수익",
			dataIndex: "",
			key: "",
			render: (value, record) => {
				// if (record.order_detail_status === "complete" && record.commission_rate) {

				const settleStatus = record?.is_settlement;
				if (
					record.order_detail_status === "cancel_request" ||
					record.order_detail_status === "cancel_complete" ||
					record.order_detail_status === "return_request" ||
					record.order_detail_status === "return_receive" ||
					record.order_detail_status === "return_refusal" ||
					record.order_detail_status === "return_collection_complete" ||
					record.order_detail_status === "return_collection_fail" ||
					record.order_detail_status === "return_delivery" ||
					record.order_detail_status === "return_delivery_complete" ||
					record.order_detail_status === "return_complete"
				) {
					return "-";
				} else {
					if (record?.commission_rate) {
						if (settleStatus || settleStatus === null) {
							let profit = Math.round(
								record.total_price * (record.commission_rate / 100)
							);
							if (profit >= 50000) {
								return (
									<span style={{ fontWeight: "bold", color: "#117ffa" }}>
										{profit.toLocaleString()}
									</span>
								);
							} else
								return (
									<span style={{ color: "#117ffa" }}>
										{profit.toLocaleString()}
									</span>
								);
						} else return "-";
					}
				}
			},
		},
		// {
		//     title: `${orderList[0]?.vat ? "부가가치세" : "원천세"}`,
		//     dataIndex: 'vat',
		//     key: `vat`,
		//     render: (value, record) => {
		//         const settleStatus = record?.is_settlement;
		//         if (record.order_detail_status === "cancel_request"
		//             || record.order_detail_status === "cancel_complete"
		//             || record.order_detail_status === "return_complete"
		//         ) {
		//             return "-"
		//         } else {
		//             if (value) {
		//                 if (record?.commission_rate) {
		//                     let profit = record.total_price * (record.commission_rate / 100);
		//                     if (settleStatus || settleStatus === null) {
		//                         return Math.round(profit * 0.1).toLocaleString()
		//                     } else return "-"
		//                 } else return "-"
		//             } else {
		//                 if (record?.commission_rate) {
		//                     let profit = record.total_price * (record.commission_rate / 100);
		//                     if (settleStatus || settleStatus === null) {
		//                         return Math.round(profit * 0.033).toLocaleString()
		//                     } else return "-"
		//                 } else return "-"
		//             }
		//         }
		//     }
		// },
		// {
		//     title: `정산금액`,
		//     dataIndex: 'vat',
		//     key: `vat`,
		//     render: (value, record) => {
		//         const settleStatus = record?.is_settlement;
		//         if (record.order_detail_status === "cancel_request"
		//             || record.order_detail_status === "cancel_complete"
		//             || record.order_detail_status === "return_complete"
		//         ) {
		//             return "-"
		//         } else {
		//             if (value) {
		//                 if (record?.commission_rate) {
		//                     let profit = record.total_price * (record.commission_rate / 100);
		//                     profit += profit * 0.1;
		//                     // return Math.round(profit).toLocaleString()
		//                     if (settleStatus || settleStatus === null) {
		//                         return <span style={{color: "#117ffa"}}>
		//                             {Math.round(profit).toLocaleString()}
		//                         </span>
		//                     } else return "-"
		//                 } else return "-"
		//             } else {
		//                 if (record?.commission_rate) {
		//                     let profit = record.total_price * (record.commission_rate / 100);
		//                     profit -= profit * 0.033;
		//                     // return Math.round(profit).toLocaleString()
		//                     if (settleStatus || settleStatus === null) {
		//                         return <span style={{color: "#117ffa"}}>
		//                             {Math.round(profit).toLocaleString()}
		//                         </span>
		//                     } else return "-"
		//                 } else return "-"
		//             }
		//         }
		//     }
		// },
		{
			title: "정산상태",
			dataIndex: "",
			key: "",
			// filters: [
			//     {
			//         text: '정산완료',
			//         value: 'success',
			//     },
			//     {
			//         text: '정산예정',
			//         value: 'ready',
			//     },
			//     {
			//         text: '정산불능',
			//         value: 'fail',
			//     },
			// ],
			// onFilter: (value, record) => {
			//     const settleStatus = record?.is_settlement;
			//     if (record.order_detail_status === "cancel_request" || record.order_detail_status === "cancel_complete") {
			//         if (value === "fail") {
			//             return true;
			//         }
			//     } else {
			//         if (settleStatus && value === "success") {
			//             return true;
			//         } else {
			//             if (settleStatus === null && value === "ready") {
			//                 return true;
			//             } else {
			//                 if (value === "fail") return false;
			//             }
			//         }
			//     }
			// },
			render: (value, record) => {
				const settleStatus = value?.is_settlement;
				if (
					record.order_detail_status === "cancel_request" ||
					record.order_detail_status === "cancel_complete" ||
					record.order_detail_status === "return_request" ||
					record.order_detail_status === "return_receive" ||
					record.order_detail_status === "return_refusal" ||
					record.order_detail_status === "return_collection_complete" ||
					record.order_detail_status === "return_collection_fail" ||
					record.order_detail_status === "return_delivery" ||
					record.order_detail_status === "return_delivery_complete" ||
					record.order_detail_status === "return_complete"
				) {
					return <span style={{ color: "#ADB5BD" }}>정산불능</span>;
				} else {
					if (settleStatus) {
						return <span style={{ color: "#117ffa" }}>정산완료</span>;
					} else {
						if (settleStatus === null) {
							return <span>정산예정</span>;
						} else {
							return <span style={{ color: "#ADB5BD" }}>정산불능</span>;
						}
					}
				}
			},
		},
	];

	useEffect(() => {
		getStatisticsStatus();
		getOrderList("initial");
	}, []);

	useEffect(() => {
		getOrderList();
	}, [orderType, orderBy]);

	useEffect(() => {
		if (navClicked === "1") {
			getStatisticsStatus("initial");
			getOrderList("initial");
		} else {
			getOrderList();
		}
	}, [navClicked]);

	useEffect(() => {
		setOrderList(orderTotalList.slice(offset, offset + pageSize));
	}, [offset]);

	useEffect(() => {
		setOffset(0);
		setCurrentPageNumber(1);
		getOrderList("initial");
	}, [pageSize]);

	const getOrderList = async (type = "") => {
		setIsLoading(true);
		try {
			const linkParam = {
				userId: user?.id,
			};
			const linkRes = await api.getProductLinkList(linkParam);
			if (
				linkRes.data.code === 200 &&
				linkRes.data.result &&
				linkRes.data.result.length > 0
			) {
				const linkList = linkRes.data.result.map((link) => link.query);
				const query = linkList.join(",");
				const param = {
					startDate:
						type === "initial"
							? moment().startOf("day").format("YYYYMMDDHHmm")
							: searchOptions.startDate
							? searchOptions.startDate.startOf("day").format("YYYYMMDDHHmm")
							: moment()
									.subtract(1, "months")
									.startOf("day")
									.format("YYYYMMDDHHmm"),
					endDate:
						type === "initial"
							? moment().endOf("day").format("YYYYMMDDHHmm")
							: searchOptions.endDate
							? searchOptions.endDate.endOf("day").format("YYYYMMDDHHmm")
							: moment().endOf("day").format("YYYYMMDDHHmm"),
					queryList: query,
					orderType: orderType,
					orderBy: orderBy,
				};
				const res = await orderApi.orderByInfluencer(param);
				if (res.code === 200) {
					if (res.result.userOrderDetailDTOList.length > 1) {
						if (orderType === "created_at") {
							if (orderBy === "desc") {
								res.result.userOrderDetailDTOList.sort(
									(a, b) => moment(b.created_at) - moment(a.created_at)
								);
							} else {
								res.result.userOrderDetailDTOList.sort(
									(a, b) => moment(a.created_at) - moment(b.created_at)
								);
							}
						}
					}
					// let filterList = res.result.userOrderDetailDTOList.filter((item) => item.seller_id === 25).filter((item) => item.order_detail_status === "complete");
					// let filterTotal = 0;
					// filterList.map((item) => {
					//
					//     console.log(item);
					// })
					setOrderTotalList(res.result.userOrderDetailDTOList);
					if (type === "initial" || type === "search") {
						setOrderList(res.result.userOrderDetailDTOList.slice(0, pageSize));
					} else {
						setOrderList(
							res.result.userOrderDetailDTOList.slice(offset, offset + pageSize)
						);
					}
					if (res.result.length !== 0) {
						setTotalSize(res.result.totalCnt);
					} else {
						setTotalSize(0);
					}
					setUpdateDate(moment());
				} else {
					throw res.msg;
				}
			}
			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
			toastAlert(error);
		}
	};

	const getStatisticsStatus = async (type = "") => {
		// if (user.query) {
		// setIsLoading(true)
		try {
			// let queryForAdmin = ""
			// if (user.query === "admin") {
			//     const queryListRes = await partnersApi.getQueryList()
			//     if (queryListRes.code === 200) {
			//         queryForAdmin = queryListRes.result.join(",")
			//     }
			// }
			const linkParam = {
				userId: user?.id,
			};
			const linkRes = await api.getProductLinkList(linkParam);
			if (
				linkRes.data.code === 200 &&
				linkRes.data.result &&
				linkRes.data.result.length > 0
			) {
				const linkList = linkRes.data.result.map((link) => link.query);
				const query = linkList.join(",");
				const queryLogParam = {
					startDate:
						type === "initial"
							? moment().startOf("day").format("YYYYMMDDHHmm")
							: searchOptions.startDate
							? searchOptions.startDate.startOf("day").format("YYYYMMDDHHmm")
							: moment()
									.subtract(1, "months")
									.startOf("day")
									.format("YYYYMMDDHHmm"),
					endDate:
						type === "initial"
							? moment().endOf("day").format("YYYYMMDDHHmm")
							: searchOptions.endDate
							? searchOptions.endDate.endOf("day").format("YYYYMMDDHHmm")
							: moment().endOf("day").format("YYYYMMDDHHmm"),
					query: query,
				};
				const param = {
					startDate:
						type === "initial"
							? moment().startOf("day").format("YYYYMMDDHHmm")
							: searchOptions.startDate
							? searchOptions.startDate.startOf("day").format("YYYYMMDDHHmm")
							: moment()
									.subtract(1, "months")
									.startOf("day")
									.format("YYYYMMDDHHmm"),
					endDate:
						type === "initial"
							? moment().endOf("day").format("YYYYMMDDHHmm")
							: searchOptions.endDate
							? searchOptions.endDate.endOf("day").format("YYYYMMDDHHmm")
							: moment().endOf("day").format("YYYYMMDDHHmm"),
					queryList: query,
				};
				const queryLogRes = await queryLogApi.queryLogByInfluencer(
					queryLogParam
				);
				const res = await orderApi.orderStatistics(param);
				if (queryLogRes.code === 200 && res.code === 200) {
					setStatistics({
						click: queryLogRes.result,
						purchases_num: res.result.purchases_num ?? 0,
						purchases_complete_num: res.result.purchases_complete_num ?? 0,
						cvr:
							queryLogRes.result &&
							queryLogRes.result !== 0 &&
							res.result.purchases_complete_num
								? (
										(res.result.purchases_complete_num / queryLogRes.result) *
										100
								  ).toFixed(2)
								: 0.0,
						combined_amount: res.result.combined_amount ?? 0,
						expected_profit_amount: res.result.expected_profit_amount ?? 0,
						profit_amount: res.result.profit_amount ?? 0,
						total_price: res.result.total_purchase_amount ?? 0,
					});
				} else if (queryLogParam.code !== 200) {
					throw queryLogParam.msg;
				} else {
					throw res.msg;
				}
			} else {
				setStatistics({
					click: 0,
					purchases_num: 0,
					purchases_complete_num: 0,
					cvr: 0.0,
					combined_amount: 0,
					expected_profit_amount: 0,
					profit_amount: 0,
				});
			}

			// setIsLoading(false)
		} catch (error) {
			// setIsLoading(false)
			toastAlert(error);
		}
	};

	const handleSearch = () => {
		setOffset(0);
		setCurrentPageNumber(1);
		if (searchOptions.startDate === null || searchOptions.endDate === null) {
			toastAlert("조회하려는 기간이 없습니다. 다시 설정해주시길 바랍니다.");
			return false;
		} else {
			if (!searchOptions.startDate.isBefore(searchOptions.endDate)) {
				toastAlert(
					"조회하려는 기간이 잘못 설정되어있습니다. 다시 시도해주시길 바랍니다."
				);
				return false;
			} else {
				getStatisticsStatus();
				getOrderList("search");
				return true;
			}
		}
	};

	const handleCancelBtnClick = () => {
		setSearchOptions({
			startDate: moment().startOf("day"),
			endDate: moment().endOf("day"),
		});
		setOffset(0);
		getStatisticsStatus("initial");
		getOrderList("initial");
	};

	const handelTableChange = (pagination, filters, sorter) => {
		if (sorter) {
			//sorting 이벤트가 이루어졌을때
			if (sorter.order) {
				if (sorter.order === "descend") {
					setOrderBy("desc");
				} else if (sorter.order === "ascend") {
					setOrderBy("asc");
				}
				setOrderType(sorter.field);
				//sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
			} else {
				setOrderType("created_at");
				setOrderBy("desc");
			}
		}
	};

	/**
	 * page 넘김
	 */
	const handleChangePagination = (pageNumber) => {
		const currOffset = (pageNumber - 1) * pageSize;
		setCurrentPageNumber(pageNumber);
		setOffset(currOffset);
	};

	useEffect(() => {
		if (detail) {
			getStatisticsStatus();
			getOrderList("search");
			setDetail(false);
		}
	}, [searchOptions, detail]);

	/**
	 * 자세히 버튼 클릭
	 * @param e
	 * @param value
	 */
	const settlementChange = (e, value) => {
		const date = value.settlement_month;
		const settleDate = moment(date).subtract(1, "month").format("YYYY.MM.DD");
		setSearchOptions({
			startDate: moment(settleDate).startOf("month"),
			endDate: moment(settleDate).endOf("month"),
		});
		setNavClicked("2");
		setDetail(true);
	};

	const dropdownItems = (
		<Menu>
			<Menu.Item style={{ fontSize: "0.9em" }} onClick={() => setPageSize(10)}>
				10개씩 보기
			</Menu.Item>
			<Menu.Item style={{ fontSize: "0.9em" }} onClick={() => setPageSize(20)}>
				20개씩 보기
			</Menu.Item>
			<Menu.Item style={{ fontSize: "0.9em" }} onClick={() => setPageSize(30)}>
				30개씩 보기
			</Menu.Item>
		</Menu>
	);

	const renderEmpty = () => (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
			}}
		>
			<img
				src={`/assets/images/report/empty-data.png`}
				alt={`채널 이미지`}
				style={{ height: 70, width: 70 }}
			/>
			<span style={{ color: "rgba(0, 0, 0, 0.25)" }}>
				리포트가 비었습니다 지금부터 당영투게더와 함께하세요!
			</span>
		</div>
	);

	const handleExcelDown = () => {
		console.log("handleExcelDown");
		let excelData = [];
		excelData = orderTotalList?.map((row) => {
			// let commission_dy = row.is_cooperate ? 0 : Math.floor(row.total_price * 0.11);
			// let commission_sell = row.is_cooperate
			//     ? Math.floor(row.total_price * ((row.cooperate_fee_rate * 1.1) / 100)) :
			//     row.is_influencer
			//         ? Math.floor(row.total_price * (row.influencer_fee_rate / 100)) : 0
			// let profit_price = row.total_price
			// if (row.is_cooperate) {
			//     profit_price = profit_price - Math.floor(row.total_price * ((row.cooperate_fee_rate * 1.1) / 100))
			// } else {
			//     if (row.is_influencer) {
			//         profit_price = profit_price - Math.floor(row.total_price * (row.influencer_fee_rate / 100))
			//     }
			//     profit_price = profit_price - Math.floor(row.total_price * 0.11)
			// }

			let commissionStatus = "";
			if (
				row.order_detail_status === "cancel_request" ||
				row.order_detail_status === "cancel_complete" ||
				row.order_detail_status === "return_request" ||
				row.order_detail_status === "return_receive" ||
				row.order_detail_status === "return_refusal" ||
				row.order_detail_status === "return_collection_complete" ||
				row.order_detail_status === "return_collection_fail" ||
				row.order_detail_status === "return_delivery" ||
				row.order_detail_status === "return_delivery_complete" ||
				row.order_detail_status === "return_complete"
			) {
				commissionStatus = "정산불능";
			} else {
				if (row?.is_settlement) {
					commissionStatus = "정산완료";
				} else {
					if (row?.is_settlement === null) {
						commissionStatus = "정산예정";
					} else {
						commissionStatus = "정산불능";
					}
				}
			}
			// let vat_title = row.vat ? "corporation_vat" : "individual_tax";
			// let profit = row.total_price * (row.commission_rate / 100);
			// let vat_price = 0;
			// let profit_price = 0;
			// if (row.vat) {
			// vat_price = Math.round(profit * 0.1);
			// profit_price = Math.round(profit * 1.1);
			// } else {
			// vat_price = Math.round(profit * 0.033);
			// profit_price = Math.round(profit * 0.967);
			// }
			return {
				// order_id: row.order_id,
				// order_detail_id: `dy${row.order_detail_id}`,
				brand_name: row.product_brand_name,
				// product_id: row.product_id,
				// option_id: row.option_id,
				product_name: row.product_name,
				option_title: row.option_title,
				created_at: moment(row.created_at).format("YYYY.MM.DD HH:mm"),
				complete_date: row.complete_date
					? moment(row.complete_date).format("YYYY.MM.DD HH:mm")
					: "",
				// name: row.name,
				order_detail_status:
					status.matchingOrderStatus[row.order_detail_status],
				total_price: row.total_price,
				commission_rate: row.commission_rate + "%",
				profit:
					commissionStatus === "정산불능"
						? 0
						: Math.round(row.total_price * (row.commission_rate / 100)),
				// [vat_title]: vat_price,
				// profit_price: profit_price,
				status: commissionStatus,
			};
		});
		const wb = XLSX.utils.book_new();
		const ws = XLSX.utils.json_to_sheet(excelData);
		Object.keys(excelData[0]).forEach((key, idx) => {
			const cellAdd = XLSX.utils.encode_cell({ c: idx, r: 0 });
			ws[cellAdd].v = status.matchingKey[key];
		});
		XLSX.utils.book_append_sheet(wb, ws, "정산상태");
		// XLSX.writeFile(wb, `${moment().format("YYYYMMDD")}_정산상태.xlsx`)
		XLSX.writeFile(
			wb,
			`${searchOptions.startDate.format(
				"YYMMDD"
			)}-${searchOptions.endDate.format("YYMMDD")}_정산상태.xlsx`
		);
	};
	let normalUser = !user?.role || user?.role === "level_2";
	return (
		<div className="main-wrap">
			<div className="max-width-apply">
				<LinkComponent />
				<h1 className="main-title">
					{/*판매・정산*/}
					리포트
				</h1>

				<div className={`main-nav`}>
					{/*{user?.role === "super_admin" && (*/}
					{!normalUser && (
						<button
							onClick={() => {
								history.push(`/reports_analysis/category`);
							}}
						>
							채널 분석
						</button>
					)}
					<button
						className={`${navClicked === "1" ? "clicked" : ""}`}
						onClick={() => {
							history.push(`/reports`);
							if (navClicked !== "1") {
								setSearchOptions({
									startDate: moment().startOf("day"),
									endDate: moment().endOf("day"),
								});
								setOffset(0);
							}
							setNavClicked("1");
						}}
					>
						판매
					</button>
					<button
						className={`${navClicked === "2" ? "clicked" : ""}`}
						onClick={() => setNavClicked("2")}
					>
						정산
					</button>
				</div>
				{navClicked === "2" ? (
					<ReportSettlementComponent
						settlementChange={settlementChange}
						statistics={statistics}
						orderList={orderList}
					/>
				) : (
					<>
						<ReportDateSearchComponent
							searchOptions={searchOptions}
							setSearchOptions={setSearchOptions}
							updateDate={updateDate}
							handleSearch={handleSearch}
							handleCancelBtnClick={handleCancelBtnClick}
						/>
						<ReportStatisticsComponent
							statistics={statistics}
							orderList={orderList}
						/>
						<Row
							justify={"space-between"}
							align={"middle"}
							style={{ padding: "2em 0 1em" }}
						>
							<p style={{ margin: 0, fontWeight: "bold", fontSize: "0.9em" }}>
								목록 총 {totalSize}개
							</p>
							<Row align={"middle"} style={{ gap: "5px" }}>
								<Dropdown overlay={dropdownItems} trigger={"click"}>
									<Button
										size={`small`}
										style={{
											fontSize: "0.9em",
											display: "flex",
											alignItems: "center",
											justifyContent: "space-between",
											width: "10em",
										}}
									>
										{pageSize}개씩 보기
										<img
											src={`/assets/images/report/dropdown.png`}
											alt={`드롭다운`}
											style={{
												height: "auto",
												width: "0.8em",
											}}
										/>
									</Button>
									{/*<img*/}
									{/*    src={`/assets/images/products/review.png`}*/}
									{/*    alt={`화살표`}*/}
									{/*    style={{*/}
									{/*        height: "0.8em",*/}
									{/*        width: "auto"*/}
									{/*    }}*/}
									{/*/>*/}
								</Dropdown>
								<Button
									size={`small`}
									onClick={handleExcelDown}
									style={{ fontSize: "0.9em" }}
								>
									<img
										src={`/assets/images/excel-icon.png`}
										alt={`화살표`}
										style={{
											height: "1em",
											width: "auto",
											marginRight: "5px",
										}}
									/>
									엑셀다운
								</Button>
							</Row>
						</Row>
						<ConfigProvider renderEmpty={renderEmpty}>
							<Table
								className="report-table-wrap"
								columns={columns}
								dataSource={orderList}
								loading={isLoading}
								rowKey="order_detail_id"
								scroll={{ x: "max-content" }}
								tableLayout="auto"
								footer={() => <></>}
								onChange={handelTableChange}
								showSorterTooltip={false}
								pagination={false}
								size={`small`}
								style={{
									margin: 0,
								}}
							/>
						</ConfigProvider>
						<Pagination
							className="report-pagination-wrap"
							showSizeChanger={false}
							current={currentPageNumber}
							pageSize={pageSize}
							total={totalSize}
							onChange={handleChangePagination}
						/>
					</>
				)}
			</div>
		</div>
	);
};

export default Reports;
